import React from 'react';

import Links from "../Links";

export default function Drawer(props) {
  return <div className="portfolio-drawer mdl-layout__drawer">
    <Links />
  </div>
}



// WEBPACK FOOTER //
// ./src/Drawer/Drawer.js